import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-abm',
  templateUrl: './modal-abm.component.html',
  styleUrls: ['./modal-abm.component.scss']
})
export class ModalAbmComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ModalAbmComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: UntypedFormBuilder
  ) {
    //console.log(data)
  }

  ngOnInit() {
    this.createForm();
  }

  cerrarModal(result: { status, mensaje }) {
    this.dialogRef.close(result);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      descripcion: []
    })
  }

}
